/**
 * @generated SignedSource<<21a2d4bb797b76393697a55b247922c4>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfileLikeBottomSheet_profile$data = {
  readonly name: string;
  readonly " $fragmentType": "ProfileLikeBottomSheet_profile";
};
export type ProfileLikeBottomSheet_profile$key = {
  readonly " $data"?: ProfileLikeBottomSheet_profile$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileLikeBottomSheet_profile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileLikeBottomSheet_profile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Profile",
  "abstractKey": null
};

(node as any).hash = "83d7930811c8754bf846b0041cc5dde4";

export default node;
